import { CornerRadiusModel } from '@common/models';
import { RootState } from '@redux/store';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface CornerRadiiState {
    selectedCornerRadius?: CornerRadiusModel;
}

const initialState: CornerRadiiState = {
    selectedCornerRadius: undefined,
};

const cornerRadiiSlice = createSlice({
    name: 'cornerRadius',
    initialState,
    reducers: {
        updateSelectedCornerRadius: (state, action: PayloadAction<CornerRadiusModel>) => {
            state.selectedCornerRadius = action.payload;
        },
        resetSelectedCornerRadius: (state) => {
            state.selectedCornerRadius = initialState.selectedCornerRadius;
        },
    },
});

export const { updateSelectedCornerRadius, resetSelectedCornerRadius } = cornerRadiiSlice.actions;

export const selectSelectedCornerRadius = ({ cornerRadius }: RootState): CornerRadiusModel | undefined =>
    cornerRadius.selectedCornerRadius;

export default cornerRadiiSlice.reducer;
